export enum KycStatus {
  CREATED = 'created',
  IN_PROGRESS = 'in_progress',
  IN_REVIEW = 'in_review',
  NEED_CUSTOMER_REVIEW = 'need_customer_review',
  PARTIALLY_COMPLETED = 'partially_completed', // partially completed by customer, waiting for complete other phases
  COMPLETED = 'completed',
  DISABLED = 'disabled',
}

export const KYC_LABELS: any = {
  [KycStatus.CREATED]: 'Creado',
  [KycStatus.IN_PROGRESS]: 'En progreso',
  [KycStatus.IN_REVIEW]: 'En revisión',
  [KycStatus.NEED_CUSTOMER_REVIEW]: 'Revisión cliente',
  [KycStatus.PARTIALLY_COMPLETED]: 'Parcialmente completado',
  [KycStatus.COMPLETED]: 'Completado',
  [KycStatus.DISABLED]: 'Deshabilitado',
};
